import React from "react";
import { motion } from "framer-motion";
import { Truck, Calendar } from "@phosphor-icons/react";

const ITEMS = [
  {
    icon: Truck,
    title: "We come to you",
    text: "Home, office, apartment garage — professional mobile detailing brought to your address. You don't move a thing.",
  },
  {
    icon: Calendar,
    title: "Easy scheduling",
    text: "Book in under 90 seconds. Same-week appointments. Reminders so you never miss your slot.",
  },
];

export default function WhyUs() {
  return (
    <section id="why-us" data-testid="whyus-section" className="section bg-[#0a0a0a] border-y border-white/5">
      <div className="container-pd">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <div className="divider-gold" />
              <span className="eyebrow">02 · Why Velocity</span>
            </div>
            <h2 className="font-display font-black text-white text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-[1.05]">
              Built for busy owners who refuse to compromise.
            </h2>
            <p className="mt-6 text-zinc-400 leading-relaxed">
              We obsess over the finish so you don&apos;t have to think about it.
              Every detail is logged, photographed, and inspected before we leave.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {ITEMS.map(({ icon: Icon, title, text }, i) => (
              <motion.div
                key={title}
                data-testid={`whyus-item-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="p-7 bg-[#0c0c0c] border border-white/5 hover:border-[#D4AF37]/30 transition-colors"
              >
                <Icon size={28} weight="duotone" className="text-[#D4AF37]" />
                <h3 className="mt-5 font-display font-bold text-xl text-white">{title}</h3>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
